/**
 * @generated SignedSource<<dd604798bb3e2e8ae913963644b88b3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RepeatTypeEnum = "daily" | "monthly" | "weekly" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AppPushDescriptionList_appPush$data = {
  readonly created: any;
  readonly deeplink: string | null;
  readonly id: string;
  readonly pushBody: string;
  readonly pushTitle: string;
  readonly repeatType: RepeatTypeEnum | null;
  readonly repeatValue: string | null;
  readonly startAt: any;
  readonly " $fragmentSpreads": FragmentRefs<"AppPushStatusLabel_appPush">;
  readonly " $fragmentType": "AppPushDescriptionList_appPush";
};
export type AppPushDescriptionList_appPush$key = {
  readonly " $data"?: AppPushDescriptionList_appPush$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppPushDescriptionList_appPush">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppPushDescriptionList_appPush",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pushTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pushBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deeplink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AppPushStatusLabel_appPush"
    }
  ],
  "type": "AppPush",
  "abstractKey": null
};

(node as any).hash = "7661d5dec1e036088ae16b5a5458d32f";

export default node;
